import { DateRangeSchema, sortOrderType } from '@/utils';
import { z } from 'zod';
import { NAME_MAX_LENGTH } from '../utils';

const ExpenditureBudgetJurisdictionBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z.number().int().min(1).nullish(),
  name: z.string().min(1),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  sortOrder: sortOrderType.max(9999),
});

export const ExpenditureBudgetJurisdictionsModel =
  ExpenditureBudgetJurisdictionBaseModel.array();
export const ExpenditureBudgetJurisdictionModel =
  ExpenditureBudgetJurisdictionBaseModel;

export const ExpenditureBudgetJurisdictionFormSchema =
  ExpenditureBudgetJurisdictionBaseModel.pick({
    code: true,
    sortOrder: true,
  }).extend({
    name: ExpenditureBudgetJurisdictionBaseModel.shape.name.max(
      NAME_MAX_LENGTH,
    ),
    period: DateRangeSchema.nullish(),
  });
